export default {"src":"/_next/static/media/gray-entry-point.077f253e.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};